import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//币种
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//国家
export async function getDqList(params) {
    return post(oaserver+'/oacurrency/getDqList', params, true);
}
//总行
export async function getParentBankList(params) {
    return post(oaserver+'/dict/bank/getParentBankList', params, true);
}
//支行
export async function getSubBankList(params) {
    return post(oaserver+'/dict/bank/getSubBankList', params, true);
}
//新增公司
export async function addCompany(params) {
    return post(oaserver+'/organize/addCompany', params, true);
}
//公司列表
export async function getCompanyList(params) {
    return post(oaserver+'/organize/getCompanyList', params, true);
}
//集团公司列表
export async function getGroupCompanyList(params) {
    return post(oaserver+'/organize/getGroupCompanyList', params, true);
}
//银行新增
export async function addCompanyBankList(params) {
    return post(oaserver+'/organize/addCompanyBankList', params, true);
}
//银行状态
export async function updateCompanyBankState(params) {
    return post(oaserver+'/organize/updateCompanyBankState', params, true);
}
//银行列表
export async function getCompanyBankList(params) {
    return post(oaserver+'/organize/getCompanyBankList', params, true);
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
///单位接口
export async function getDictList(param) {
    return post(oaserver+'/oacurrency/getDictList',param,true)
}